import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavService } from '../../shared/layouts/side-nav/services/side-nav.service';
import { GrentRoutingModule } from './grent-routing.module';
import grentSidenavConfig from './grentSidenavConfig';
/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * NOTE THAT THIS MODULE WILL BE LOADED IN THE APP.
 * DO NOT IMPORT ANYTHING IN HERE.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */

@NgModule({
  declarations: [],
  imports: [CommonModule, GrentRoutingModule],
  exports: [],
  providers: [],
})
export class GrentModule {
  constructor(private sideNavService: SideNavService) {
    /**
     * CODE IN HERE WILL BE EXECUTED ON APP LOAD.
     * USE IT TO INJECT YOUR SUB APP INTO THE MAIN APPLICATION
     */
    this.sideNavService.addSubMenuItems(
      'grent_application',
      grentSidenavConfig.grentLinks,
    );

    this.sideNavService.addSubMenuItems(
      'setting',
      grentSidenavConfig.grentSettingsLink,
    );
  }
}
